'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'space-station-moon-construction';
var width = 512;
var height = 512;
var aliases = ["space-station-moon-alt"];
var unicode = 'e034';
var svgPathData = ['M48 256c0 12.8 1.1 25.2 3.3 37.4l1.5 .5c34.9 12.6 94.8 34.1 203.2 34.1 78.8 0 132-11.4 168-22.3l0-17.7c0-13.3 10.7-24 24-24l0-40-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-32 0c-13.3 0-24-10.7-24-24 0-11.6 8.3-21.4 19.3-23.5-34.5-25.4-77.1-40.5-123.3-40.5-114.9 0-208 93.1-208 208zm22.7 94.7c34.4 67.3 104.5 113.3 185.3 113.3 55.6 0 106.1-21.8 143.4-57.4 4.6-4.4 10.6-6.6 16.6-6.6l0-42.2c-38.3 9.7-90.1 18.2-160 18.2-87.1 0-146.1-13.3-185.3-25.3zM304 176a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z', 'M48 256c0-114.9 93.1-208 208-208 46.2 0 88.8 15 123.3 40.5-11 2.2-19.3 11.9-19.3 23.5 0 13.3 10.7 24 24 24l53.9 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.1-2.8-25.4C409.9 38 337.4 0 256 0 114.6 0 0 114.6 0 256S114.6 512 256 512c68.4 0 130.6-26.9 176.6-70.6 9.6-9.1 10-24.3 .8-33.9s-24.3-10-33.9-.8c-37.3 35.6-87.8 57.4-143.4 57.4-80.8 0-150.8-46.1-185.3-113.3 39.2 12.1 98.2 25.3 185.3 25.3 97.8 0 160-16.6 199.7-30 9.8-3.3 16.3-12.4 16.3-22.7l0-35.3c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 17.7c-36 10.8-89.2 22.3-168 22.3-108.4 0-168.3-21.5-203.2-34.1l-1.5-.5C49.1 281.2 48 268.8 48 256zm112-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm144 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpaceStationMoonConstruction = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;